<template>
  <!-- @mouseleave="visible = false" -->
  <div class="Overlay" @mouseleave="visible = false">
    <!-- <img class="Point-Img" @mouseenter="pointMap"  :src="stateMap.imageUrl" alt=""> -->
    <img class="Point-Img" @mouseenter="pointMap" src="../../../assets/png/qiziPoint.png" alt="">
    <el-popover
      placement="left"
      title=""
      width="300"
      :offset="10"
      trigger="manual"
      v-model="visible">
      <div class="Map-Show-Content" @click="toStockDetail">
         <div class="MSC-Left">
          <span v-if="stockMap.price > 0">{{ stockMap.price }} {{ stockMap.currency }}</span>
          <span v-else>点击询价</span>
          <img id="pic-class" :src="pic ? pic : noImage" alt="">
         </div>
         <div class="MSC-Right">
            <div class="name">{{ stockMap.nameCn }}</div>
            <div class="address">
              <i v-if="stockMap.addressCn" class="el-icon-location-outline van-icon" />
              <span class="ellipsis">{{ stockMap.addressCn }}</span>
            </div>
         </div>
      </div>
    </el-popover>
    <stockDetail ref="stockDetail"></stockDetail>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import stockDetail from '@/views/plan/info/ResourceDetail.vue'
import axios from 'axios'
export default {
  name:  '',
  components: {
    stockDetail
  },
  // 定义属性
  data() {
    return {
      noImage: require('@/assets/png/noImage.png'),
      stateMap: '',
      stockMap: '',
      visible: false,
      pic: '',
      checkBudgets: ''
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toStockDetail() {
      this.$refs.stockDetail.init(this.stockMap,this.checkBudgets)
    },
    blobToDataURI(blob, callback) {
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
          callback(e.target.result);
      }
    },
    pointMap() {
      this.visible = true
      if (this.stockMap.productType == 8) {
        axios.get(this.stockMap.imageUrl,{
          params:{},
          responseType: 'blob',
          headers:{}
        }).then(res=>{
          var blob =  new Blob([res.data])
          console.log('popsopdsd111',res)
          this.blobToDataURI(blob,(result) => {
            this.pic = result
            this.stockMap.imageUrl = result
          })
        })
      } else {
        this.pic = this.stockMap.imageUrl
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="scss">
  .ellipsis {
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
    display: block;
    // width: 50vw;
  }
  .Overlay {
    position: absolute;
    >img {
      height: 30px;
      width: 30px;
    }

    /deep/.el-popover{
      padding: 0px;
      margin: 0px;
      line-height: 0;
    }

    .Map-Show-Content {
      display: flex;
      white-space:normal; 
      .MSC-Right {
        padding: 5px;
        width: 200px;
        .name {
          color: #db4e1a;
          font-size: 14px;
          font-weight: 700;
          line-height: 16px;
        }
        .address {
          line-height: 2;
          display: flex;
          >i {
            display: flex;
            align-items: center;
            position: relative;
            top: 1px;
          }
        }
      }
      .MSC-Left {
        >span {
            height: 20px;
            background: white;
            width: 90px;
            // height: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #db4e1a;
            color: white;
            font-size: 14px;
          }
          >img {
            width: 90px;
            height: 60px;
            background: #e4e4e4;
          }
        }
    }
  }
</style>